<script setup>
import { ref, computed } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps({
  settings: {
    type: Object,
    default: () => ({}),
  },
});

// Get values from Elementor settings with defaults
const title = computed(() => props.settings.title || 'Hello World');
const description = computed(() => props.settings.description || 'This is an example Vue-powered Elementor widget.');
const showButton = computed(() => props.settings.show_button === 'yes');
const buttonText = computed(() => props.settings.button_text || 'Click Me');
const primaryColor = computed(() => props.settings.primary_color || '#3b82f6');
const counterStart = computed(() => parseInt(props.settings.counter_start) || 0);

// Local state
const count = ref(counterStart.value);

// Methods
function incrementCounter() {
  count.value++;
}

// Dynamic styles based on Elementor settings
const buttonStyle = computed(() => ({
  backgroundColor: primaryColor.value,
}));
</script>

<template>
  <div class="example-widget p-6 bg-white rounded-lg shadow-md border border-gray-200">
    <h2 class="text-2xl font-bold text-gray-900 mb-2">
      {{ title }}
    </h2>

    <p class="text-gray-600 mb-4">
      {{ description }}
    </p>

    <div class="flex items-center gap-4">
      <div class="text-lg">
        Counter: <span class="font-bold text-primary-600">{{ count }}</span>
      </div>

      <button
        v-if="showButton"
        :style="buttonStyle"
        class="px-4 py-2 text-white font-medium rounded-md hover:opacity-90 transition-opacity"
        @click="incrementCounter"
      >
        {{ buttonText }}
      </button>
    </div>

    <div class="mt-4 pt-4 border-t border-gray-200 text-sm text-gray-500">
      This widget demonstrates Vue + Elementor integration.
      Edit settings in Elementor to customize.
    </div>
  </div>
</template>

<style scoped>
.example-widget {
  font-family: 'Inter', system-ui, sans-serif;
}
</style>
